var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8723 8.63387L12.694 7.45554L4.93229 15.2172V16.3955H6.11063L13.8723 8.63387ZM15.0506 7.45554L16.229 6.2772L15.0506 5.09887L13.8723 6.2772L15.0506 7.45554ZM6.80063 18.0622H3.26562V14.5264L14.4615 3.33054C14.6177 3.17431 14.8297 3.08655 15.0506 3.08655C15.2716 3.08655 15.4835 3.17431 15.6398 3.33054L17.9973 5.68804C18.1535 5.84431 18.2413 6.05623 18.2413 6.2772C18.2413 6.49817 18.1535 6.7101 17.9973 6.86637L6.80146 18.0622H6.80063Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e0c4d067fd4e828b8dc8df5f59d7f854.svg";
export { ForwardRef as ReactComponent };